import type { AIModel } from '@/types';

export function isSovereignDemoModel(model: AIModel): boolean {
  const name = model.name.toLowerCase();
  return model.provider === 'maplept' || model.id === 'maplept-free' || name.includes('maplept');
}

export function getSovereignDemoModels(models: AIModel[]): AIModel[] {
  return models.filter(isSovereignDemoModel);
}

export function getPreferredSovereignDemoModel(models: AIModel[]): AIModel | undefined {
  const demoModels = getSovereignDemoModels(models);
  return demoModels.find((model) => model.provider === 'maplept')
    || demoModels.find((model) => model.id === 'maplept-free')
    || demoModels[0];
}
